import { ConstantsHelper, PoolMetadataCoreType, titleCase } from "@renec-foundation/relend-adapter"
import { atom } from "jotai"

export const configAtom = atom<PoolMetadataCoreType[]>([])

export const solendConfigs: PoolMetadataCoreType[] = ConstantsHelper.getSolendConfig().map(
  (c: { name: string; address: string; owner: string; authorityAddress: string }) => ({
    name: titleCase(c.name),
    owner: c.owner,
    address: c.address,
    authorityAddress: c.authorityAddress,
  }),
)

export const firstLoadingAtom = atom(true)
